import type { Story } from '@/src/types';

import { AuthorCard } from '../AuthorCard/AuthorCard';

import styles from './AuthorsList.module.scss';

export const AUTHORS_CARDS_ID = 'authors';

interface Props {
    authors: NonNullable<Story['authors']>;
}

export function AuthorsList({ authors }: Props) {
    if (authors.length === 0) {
        return null;
    }

    return (
        <div id={AUTHORS_CARDS_ID} className={styles.wrapper}>
            <h3 className={styles.heading}>
                {authors.length === 1 ? 'About the author' : 'About the authors'}
            </h3>
            <div className={styles.list}>
                {authors.map((author) => (
                    <AuthorCard author={author} key={author.id} />
                ))}
            </div>
        </div>
    );
}
